import React from 'react';

import PageTitle from '../components/pagetitle/PageTitle';
import Counter from '../components/counter/Counter';
import Team from '../components/team/Team';
import dataTeam from '../assets/fake-data/dataTeam';
import Footer from '../components/footer/Footer';


function About(props) {
    return (
        <div className='page-about wrapper'>

            <PageTitle title='About us' />

            <section className="about-section pt-120">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-lg-10">
                            <div className="about-content text-center">
                                <h2 className="mb-4">Welcome to PipPlus Tech</h2>
                                <p>
                                    Your trusted partner in intelligent, automated trading. We are a technology-driven fintech company committed to revolutionizing the way investors trade in the global forex market through advanced algorithmic software solutions.
                                </p>
                                <p>
                                    Our flagship product is a fully automated trading platform designed to analyze market trends, execute trades, and manage risk without manual intervention. Built on sophisticated trading algorithms and artificial intelligence, our software is tailored to deliver consistent performance while eliminating emotional and impulsive decision-making—often the downfall of many manual traders.
                                </p>

                                <h3 className="mt-5 mb-3">What We Do</h3>
                                <ul className="text-left list-style-disc pl-6">
                                    <li>Continuously scan and analyze the forex market in real time.</li>
                                    <li>Execute trades automatically based on tested strategies.</li>
                                    <li>Optimize risk management using pre-defined rules and dynamic controls.</li>
                                    <li>Offer high-speed execution to take advantage of even the smallest price movements.</li>
                                </ul>

                                <p className="mt-5">
                                    Our platform is ideal for retail investors, professional traders, and institutional clients who seek reliable, hands-off trading solutions. Whether you're a beginner or a seasoned investor, our user-friendly interface and back-tested strategies make it easy to get started and scale your trading activities.
                                </p>

                                <h3 className="mt-5 mb-3">Our Vision</h3>
                                <p>
                                    We envision a future where technology simplifies investing, allowing individuals to participate in the forex market without needing extensive experience or constant monitoring. By leveraging automation, we aim to bridge the gap between human decision-making and machine precision, empowering traders to achieve greater consistency and profitability.
                                </p>

                                <h3 className="mt-5 mb-3">Why Choose Us?</h3>
                                <ul className="text-left list-style-disc pl-6">
                                    <li>Proven Technology: Our software is built by experienced developers and tested across various market conditions.</li>
                                    <li>24/5 Automated Trading: Trade the forex markets around the clock without being tied to your screen.</li>
                                    <li>Real-Time Analytics: Monitor trade performance and market insights with detailed reports and dashboards.</li>
                                    <li>Dedicated Support: Our expert team provides onboarding, technical assistance, and strategic guidance to help you succeed.</li>
                                </ul>

                                <h3 className="mt-5 mb-3">Compliance & Security</h3>
                                <p>
                                    We prioritize the security and privacy of our clients. Our trading systems are built with high-level encryption and adhere to industry standards to ensure safe and secure trading. We operate transparently and encourage responsible trading practices.
                                </p>

                                <p className="mt-4 font-semibold">
                                    Let PipPlus Tech be your edge in the forex market. Discover the power of automation and take control of your trading journey today.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <Counter />  

            <Team data={dataTeam} />

           
            <Footer />
        </div>
    );
}

export default About;
